import React from 'react';
export function ConclusionSection() {
  return <section className="text-lg leading-relaxed text-[#1B1B2F]" data-id="element-246">
      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-247">Mein Fazit und Ihr Weg</h2>
      <p className="mb-4" data-id="element-248">
        Ich nenne hier bewusst nicht den Namen der konkreten Marke, bei der ich
        letztlich nach der Beratung mit meinem Arzt geblieben bin.
      </p>
      <p className="mb-4" data-id="element-249">
        Warum? Weil mein größter Fehler mit 55 Jahren darin bestand, dass ich
        „der Masse gefolgt" bin. Ich kaufte das, was alle nahmen, was in den
        Top-Rankings stand und in aller Munde war. Ich dachte nicht an mein
        Alter, an meine Gefäße und daran, wie die Biochemie funktioniert. Ich
        drückte einfach auf den Button „Kaufen" beim beliebtesten Produkt.
      </p>
      <p className="mb-4" data-id="element-250">
        Ich möchte nicht, dass Sie meinen Weg einfach wiederholen, selbst wenn
        er Ihnen jetzt richtig erscheint. Ich möchte, dass Sie:
      </p>
      <ul className="list-disc list-inside ml-4 mb-6 font-bold text-[#2B4C7E] space-y-1" data-id="element-251">
        <li data-id="element-252">Ihre Blutwerte ansehen.</li>
        <li data-id="element-253">
          Die 4 Regeln für die Wahl von Vitamin D3 oben noch einmal lesen.
        </li>
        <li data-id="element-254">
          Selbst die Zusammensetzung der Dosen, die bei Ihnen im Schrank stehen,
          mit professionellen Altersformeln vergleichen.
        </li>
      </ul>
      <p className="mb-4" data-id="element-255">
        Meine Wahl habe ich getroffen. Und es ist eine Wahl zugunsten eines
        wissenschaftlichen Ansatzes und der Sicherheit, nicht des Marketings.
        Jetzt sind Sie an der Reihe zu entscheiden, was wichtiger ist: ein
        schönes Etikett mit riesigen Zahlen oder Ihre Gesundheit und Ruhe in
        5–10 Jahren.
      </p>
      <p className="font-bold italic mb-8" data-id="element-256">
        Treffen Sie Ihre Wahl mit dem Kopf, nicht durch einen Klick auf die
        Werbung. Ihre Gesundheit in diesem Alter ist kein Feld mehr für
        Experimente.
      </p>

      <div className="border-t-2 border-[#2B4C7E] pt-8" data-id="element-257">
        <h3 className="text-xl font-bold uppercase tracking-wider text-[#2B4C7E] mb-4" data-id="element-258">
          Epilog vom Doktor (Expertenmeinung)
        </h3>
        <div className="bg-gray-50 p-6 rounded-lg italic text-gray-700" data-id="element-259">
          <p className="mb-4" data-id="element-260">
            „Annas Geschichte ist kein Einzelfall, sondern eine Gesetzmäßigkeit,
            mit der wir Ärzte immer häufiger konfrontiert werden. Wir nennen
            dies das ‚Kalzium-Paradoxon': Ein Mensch nimmt enorme Dosen Vitamin
            D3 ein, um die Knochen zu stärken, erhält aber am Ende ein brüchiges
            Skelett und ‚porzellanartige' Gefäße.
          </p>
          <p className="mb-4" data-id="element-261">
            Warum passiert das? Vitamin D3 ist der Schlüssel, der dem Kalzium
            die Tür in Ihr Blut öffnet. Aber ohne Vitamin K2 (in Form von MK-7)
            hat dieses Kalzium keinen ‚Navigator'. Es weiß nicht, dass es in das
            Knochengewebe gehen muss. Infolgedessen lagert es sich dort ab, wo
            es weicher ist: in den Arterienwänden, in den Nierengängen und sogar
            in der Augenlinse.
          </p>
          <p className="mb-4 font-semibold not-italic" data-id="element-262">
            Für Patienten über 50 ändern sich die Regeln:
          </p>
          <ul className="list-disc list-inside ml-4 mb-4 space-y-2" data-id="element-263">
            <li data-id="element-264">
              <strong data-id="element-265">Bioverfügbarkeit ist wichtiger als die Dosis:</strong>{' '}
              2.000 IE in einer richtigen Kapsel mit MCT-Öl bringen mehr Nutzen
              als 10.000 IE in einer trockenen Tablette.
            </li>
            <li data-id="element-266">
              <strong data-id="element-267">Synergie:</strong> D3 und K2 müssen gleichzeitig und in
              einem genau berechneten Verhältnis zugeführt werden.
            </li>
            <li data-id="element-268">
              <strong data-id="element-269">Sicherheit:</strong> Unsere Aufgabe in diesem Alter ist es
              nicht, die Werte in den Analysen „hochzujagen", sondern eine
              sanfte Unterstützung des Herz-Kreislauf-Systems zu gewährleisten.
            </li>
          </ul>
          <p data-id="element-270">
            Ich rate meinen Patienten immer, Präparate mit der Kennzeichnung
            Age-optimierte zu wählen. Das ist kein Marketingtrick, sondern eine
            technologische Notwendigkeit – eine Anpassung der Zusammensetzung an
            den veränderten Stoffwechsel des reifen Organismus. Passen Sie auf
            sich auf und wählen Sie mit Bedacht."
          </p>
        </div>
      </div>
    </section>;
}